import { Payment } from '@yuno/sdk-web-core/dist/types'

export const getPaymentMethodTypeList = (
  paymentMethodType?: string
): Payment.Type[] => {
  if (!paymentMethodType) return []
  return paymentMethodType
    .split(',')
    .map((item) => item.trim()) as Payment.Type[]
}


export const getMerchantLogo = (styles: string | null): string | null => {
  if (!styles) return null
  try {
    const logo = JSON.parse(styles).styles?.panel?.left?.logo
    return logo || null
  } catch {
    return null
  }
}

const CSS_COLOR_REGEX = /^(#[\da-fA-F]{3}|#[\da-fA-F]{4}|#[\da-fA-F]{6}|#[\da-fA-F]{8}|rgba?\([\d\s,./%]+\)|hsla?\([\d\s,./%]+\)|[a-zA-Z]{1,30})$/

const sanitizeCssColor = (value: unknown): string | null => {
  if (typeof value !== 'string') return null
  const trimmed = value.trim()
  return CSS_COLOR_REGEX.test(trimmed) ? trimmed : null
}

export const getCustomGlobalStyles = (styles: string | null) => {
  if (styles === null || styles === undefined) return ''

  try {
    const parsedStyles = JSON.parse(styles).styles
    if (!parsedStyles) return ''

    const { panel, checkbox, border, radio_button: radioButton } = parsedStyles

    const panelBg = sanitizeCssColor(panel?.left?.background?.color)
    const borderColor = sanitizeCssColor(border?.color)
    const radioColor = sanitizeCssColor(radioButton?.color)
    const checkboxColor = sanitizeCssColor(checkbox?.color)

    return `
    ${panelBg ? `main { background-color: ${panelBg}; }` : ''}
    ${borderColor ? `:root { --yuno-checkout-border-color: ${borderColor}; }` : ''}
    ${radioColor ? `input[type="radio"] { accent-color: ${radioColor}; }` : ''}
    ${checkboxColor ? `input[type="checkbox"] { accent-color: ${checkboxColor}; }` : ''}
  `
  } catch {
    return ''
  }
}

export const getCustomButtonStyles = (styles: string | null) => {
  if (styles === null || styles === undefined) return ''

  try {
    const style = JSON.parse(styles).styles?.button
    if (!style) return ''

    const textColor = sanitizeCssColor(style.text?.color)
    const bgColor = sanitizeCssColor(style.background?.color)
    const hoverColor = sanitizeCssColor(style.background?.hover?.color)

    const customStyles = `
    button.sdk-payments-button {
      ${textColor ? `color: ${textColor};` : ''}
      ${bgColor ? `background-color: ${bgColor};` : ''}

      ${hoverColor || bgColor ? `&:hover { background-color: ${hoverColor ?? bgColor}; }` : ''}
    }
  `

    return customStyles
  } catch {
    return ''
  }
}
